import { useViewport } from 'components/general/useViewPort';
import React, { useMemo } from "react";
import Competitor from 'components/presentation/Competitor';
import { NocMemo as Noc } from 'components/presentation/Noc';
import Label from "components/general/Label"
import { ColumnExpander, ColumnNameH2H, ColumnBib } from "components/common/TableColumns"
import StatsBox from "components/sports/bsc/views/StatsBox"
import { dateFormat } from "helpers/utils"

import LoaderSubComponent from "components/general/LoaderSubComponent";
import MirsTable from "components/general/table/Table";
import { capitalizeFirstLetter, findArray } from 'helpers/utils'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


const TableColumnsStart = () => {
  return (
    [
      ColumnBib({ disableSort: true, label: 'HeaderShirtNo', headerClassName: 'text-end w-10' }),
      ColumnNameH2H({ showCaptainAbbr: true, showSuspendedCode: true, hideNoc: true }),
      ColumnST({}),
      ColumnPosition({}),
      ColumnExpander({ type: 'alwaysTrue', idNode: 'athlete' })
    ]
  )
}

const TableColumnsSub = () => {
  return (
    [
      ColumnBib({ disableSort: true, label: '', headerClassName: 'text-end w-10' }),
      ColumnNameH2H({ showCaptainAbbr: true, showSuspendedCode: true, hideNoc: true, label: '' }),
      ColumnST({ label: '' }),
      ColumnPosition({ label: '' }),
      ColumnExpander({ type: 'alwaysTrue', idNode: 'athlete' })
    ]
  )
}

export function ColumnPosition({
  disableSort = true,
  className = 'text-start',
  headerClassName = 'text-start w-10',
  label = 'HeaderPosition',
  code = 'Position'
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: 'functionDescription',
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort,
      id: code
    }
  )
}

export function ColumnST({
  disableSort = true,
  className = 'text-center',
  headerClassName = 'text-center w-5',
  label = 'HeaderSteals',
  code = 'ST'

}) {

  return (
    {
      Header: <Label data={label} />,
      accessor: 'functionDescription',
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort,
      id: code,
      Cell: (props) => {
        let value = findArray(props.cell.row.original.eventUnitEntries, { eue_code: ['STATUS'] }).eue_value
        return value
      }
    }
  )
}

const getConfigurationBox = (date) => {

  const formatedDate = date ? dateFormat(date, "", "D MMM H:mm") : "";

  let configuration = {
    header: `Current Tournament Statistics - ${formatedDate}`,
    stats: [
      {
        order: 1,
        code: 'MP',
        attr: 'value',
        label: 'Matches Played',
        title: 'Matches Played'
      },
      {
        order: 2,
        code: 'GF',
        attr: 'value',
        label: 'Goals For',
        title: 'Goals For'
      },
      {
        order: 3,
        code: 'GA',
        attr: 'value',
        label: 'Goals Against',
        title: 'Goals Against'
      },
      {
        order: 4,
        code: 'OG',
        attr: 'value',
        label: 'Own Goals',
        title: 'Own Goals'
      },
      {
        order: 5,
        code: 'PTY',
        attr: 'value',
        label: 'Penalty Kicks for',
        title: 'Penalty Kicks for',
      },
      {
        order: 6,
        code: 'SHOT',
        attr: 'value',
        label: 'Total Shots',
        title: 'Total Shots',
      },
      {
        order: 7,
        code: 'SHOT_ON_GOAL',
        attr: 'value',
        label: 'Total shots on goal',
        title: 'Total shots on goal',
      },
      {
        order: 8,
        code: 'FOC',
        attr: 'value',
        label: 'Fouls Committed',
        title: 'Fouls Committed',
      },
      {
        order: 9,
        code: 'FOS',
        attr: 'value',
        label: 'Fouls Suffered',
        title: 'Fouls Suffered',
      },
      {
        order: 10,
        code: 'YC',
        attr: 'value',
        label: 'Single Yellow Card',
        title: 'Single Yellow Card',
      },
      {
        order: 11,
        code: 'YRC',
        attr: 'value',
        label: 'Indirect Red Card',
        title: 'Indirect Red Card',
      },
      {
        order: 12,
        code: 'RC',
        attr: 'value',
        label: 'Direct Red Card',
        title: 'Direct Red Card',
      },
      {
        order: 13,
        code: 'OHK',
        attr: 'value',
        label: 'Overhead Goals',
        title: 'Overhead Goals',
      },
      {
        order: 14,
        code: 'OHK_AVG',
        attr: 'value',
        label: 'Average Overhead Goals',
        title: 'Average Overhead Goals',
      },
    ]
  }
  return configuration;
}

const getConfigurationStart = (data, breakPoint) => {
  let configuration = {
    columns: [],
    subComponent: null,
    caption: null,
    hiddenColumns: [],
    sortBy: [],
    configs: {
    }
  };

  configuration.captionStarters = (
    <div className="d-flex justify-content-between">
      <div className='d-flex align-items-center'>
        <div className='d-none d-md-block me-1'>
          <Noc className='me-1' {...data?.participant?.organisation} />
        </div>
        <strong>
          <Competitor hidePicture={true} {...data?.participant} />
        </strong>
      </div>
      <div>
        <Uniform data={data} />
      </div>
    </div>
  )
  configuration.columns = TableColumnsStart();

  configuration.captionSubstitutes = (

    <div className='d-flex align-items-center'>
      <div className='d-none d-md-block me-8'>
        <Label data="HeaderSubstitutes" />
      </div>
    </div>
  )

  return configuration;
}

const getConfigurationSub = (data, breakPoint) => {
  let configuration = {
    columns: [],
    subComponent: null,
    caption: null,
    hiddenColumns: [],
    sortBy: [],
    configs: {
    }
  };

  configuration.captionStarters = (
    <div className="d-flex justify-content-between">
      <div className='d-flex align-items-center'>
        <div className='d-none d-md-block me-1'>
          <Noc className='me-1' {...data?.participant?.organisation} />
        </div>
        <strong>
          <Competitor hidePicture={true} {...data?.participant} />
        </strong>
      </div>
      <div>
        <Uniform data={data} />
      </div>
    </div>
  )
  configuration.columns = TableColumnsSub();

  configuration.captionSubstitutes = (

    <div className='d-flex align-items-center'>
      <div className='d-none d-md-block me-8'>
        <Label data="HeaderSubstitutes" />
      </div>
    </div>
  )

  return configuration;
}

const Uniform = ({ data }) => {
  const { mirs_discipline } = useUrlFriendlyToParameters();
  const uniform = capitalizeFirstLetter(data?.eventUnitEntries?.find(i => i?.eue_code === 'UNIFORM')?.eue_value?.toLowerCase());
  const shorts = capitalizeFirstLetter(data?.eventUnitEntries?.find(i => i?.eue_code === 'SHORTS')?.eue_value?.toLowerCase());
  return (
    <>
      <div>
        <Label data="HeaderShirts" />:&nbsp;{uniform},&nbsp;<Label data="HeaderShorts" />:&nbsp;{shorts}
      </div>
    </>
  )
}

const StartListSide = ({ data, resultStatus, config, date }) => {
  const { mirs_rsc } = useUrlFriendlyToParameters();
  const { breakPoint } = useViewport();

  const configEventStart = useMemo(() => getConfigurationStart(data, breakPoint));
  const configEventSub = useMemo(() => getConfigurationSub(data, breakPoint));

  const configBox = useMemo(() => getConfigurationBox(date));

  const renderRowSubComponent = React.useCallback(({ row }) => (
    <LoaderSubComponent component={
      <StatsBox data={row?.original} config={configBox} breakPoint={breakPoint} />
    }
    />
  ), [resultStatus]);

  const starters = data?.teamAthletes?.filter(i => i?.eventUnitEntries?.find(eui => eui?.eue_code === 'STARTER' && eui?.eue_value === 'Y'))
  const substitutes = data?.teamAthletes?.filter(i => !i?.eventUnitEntries?.find(eui => eui?.eue_code === 'STARTER' && eui?.eue_value === 'Y'))

  return (<>
    {data?.teamAthletes && (
      <div className="start-list-side-main">
        <div className="row">
          <div className="col-12">
            <MirsTable
              id={`mirs-table-start-list-starters-${mirs_rsc}-${data?.participant?.code}`}
              data={starters}
              columns={configEventStart.columns}
              renderRowSubComponent={renderRowSubComponent}
              keyRow='athlete-code'
              caption={configEventStart.captionStarters}
              initialSortBy={configEventStart.sortBy}
            />
          </div>
          <div className="col-12">
            <MirsTable
              id={`mirs-table-start-list-substitutes-${mirs_rsc}-${data?.participant?.code}`}
              data={substitutes}
              columns={configEventSub.columns}
              renderRowSubComponent={renderRowSubComponent}
              keyRow='athlete-code'
              caption={configEventSub.captionSubstitutes}
              initialSortBy={configEventSub.sortBy}
            />
          </div>
        </div>
      </div>
    )
    }
  </>)
}

export default StartListSide;
